export enum TicketGridViewType {
  TICKET = 1,
  SCHEDULED = 2,
  WATCH_LIST = 3,
  LOCATION = 4,
  AREA = 5,
  BYTICKETCOUNT ,
  BYHOURSCAPACITY
}
